<template>
  <div class="search-widget">
    <div class="content">
      <h3 class="heading--large">
        {{ greeting }}
      </h3>
      <div class="info">
        <span class="label--small">{{ currentDate }}</span>
      </div>
      <div style="width: fit-content;">
        <button
          class="button-utility"
          @click="show = true"
        >
          <i class="bi bi-search" /> Look up a business
        </button>
      </div>
    </div>
    <SearchDialog
      v-if="show"
      @close="show = false"
    />
  </div>
</template>

<script>
import SearchDialog from "@/components/pattern/searchDialog/index.vue";

export default {
  name: 'SearchWidget',
  components: {
    SearchDialog
  },
  props: {
    onSearch: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      isModalOpen: false,
      currentDate: new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }),
      currentTime: new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }),
      show: false
    }
  },
  computed: {
  greeting() {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning!";
    if (hour < 18) return "Good Afternoon!";
    return "Good Night!";
  }
},
  methods: {
    handleSearch(searchQuery) {
  this.$router.push({ 
    path: "/search-results", 
    query: { 
      businessName: searchQuery.businessName, 
      state: searchQuery.state, 
      zip: searchQuery.zip 
    } 
  });
}
  }
}
</script>

<style scoped lang="scss">
.search-widget {
  background:
    linear-gradient(263deg, rgba($color-pink, 0.75) -28.4%, rgba($color-lapis-dark, 0.75) 59.49%),
    linear-gradient(180deg, rgba(76, 0, 224, 0) 7.47%, rgba($color-lapis, 1) 100%),
    url('../../../assets/widgets/search/search-widget-background.jpeg');
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  padding: $space-large;
  @include inline-space($space-none);
  justify-content: center;
  align-items: center;
  min-height: 243px;
  width: 100%;


.content {
  @include stack-space($space-medium);
  align-items: center;
  color: $color-white;
  text-align: center;
}

.heading--large {
  margin: 0;
}

.info {
  @include inline-space($space-small);
    align-items: center;
  }

.bi-cloud-sun {
  font-size: 12px;
}
.button-utility{
  background-color: $color-white;
  color: $color-black
}
@media (max-width: $tablet-breakpoint-min-width) {
  .search-widget {
    padding: $space-medium;
  }
}
}
</style>